/**
 * Web Vitals Monitoring
 * Reports Core Web Vitals metrics
 */

import { onCLS, onFID, onLCP, onFCP, onTTFB } from 'web-vitals';

export function reportWebVitals(onPerfEntry) {
  if (onPerfEntry && typeof onPerfEntry === 'function') {
    onCLS(onPerfEntry);
    onFID(onPerfEntry);
    onLCP(onPerfEntry);
    onFCP(onPerfEntry);
    onTTFB(onPerfEntry);
  }
}

// Send metrics to analytics endpoint (if you want to collect them)
export function sendToAnalytics(metric) {
  const body = JSON.stringify(metric);
  
  // Use navigator.sendBeacon if available
  if (navigator.sendBeacon) {
    navigator.sendBeacon('/api/analytics', body);
  } else {
    // Fallback to fetch
    fetch('/api/analytics', {
      method: 'POST',
      body,
      headers: { 'Content-Type': 'application/json' },
      keepalive: true
    }).catch(console.error);
  }
}

// Example usage - uncomment if you want to track metrics
// reportWebVitals(sendToAnalytics);
